export default {
      id: "trash-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#trash",
      toString: function () {
        return this.url;
      }
    }